import { apiRequest } from "./ApiUtility";

export async function getMyAssignedServices(authContext, from, to) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = "/api/providedservices/myassignedservices";
  const data = {
    from: from,
    to: to,
    facilityId: authContext?.selectedFacility?.id,
  };

  return await apiRequest("post", url, authContext, data);
}

export async function getAllAssignedServices(authContext, from, to) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = "/api/providedservices/allassignedservices";
  const data = {
    from: from,
    to: to,
    facilityId: authContext?.selectedFacility?.id,
  };

  return await apiRequest("post", url, authContext, data);
}

export async function getLinkedServices(authContext, visitId) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/providedservices/visit/${visitId}`;
  return await apiRequest("get", url, authContext);
}

export async function getServices(authContext, filterCriteria) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = "/api/providedservices/get";
  const data = {
    facilityId: authContext?.selectedFacility?.id,
    from: filterCriteria.from,
    to: filterCriteria.to,
    status: filterCriteria.status,
    physicianId: filterCriteria.physicianId,
    visitId: filterCriteria.visitId,
  };

  return await apiRequest("post", url, authContext, data);
}

export async function getServiceDetails(authContext, serviceId) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/providedservices/${serviceId}`;
  return await apiRequest("get", url, authContext);
}

export async function addServiceToVisit(
  authContext,
  visitId,
  clinicalServiceId,
  assignedToId,
  scheduledStartDateTime,
  scheduledEndDateTime,
  notes,
  visitType
) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = "/api/providedservices";
  const data = {
    clinicalServiceId: clinicalServiceId,
    visitId: visitId,
    scheduledStartDateTime: scheduledStartDateTime,
    scheduledEndDateTime: scheduledEndDateTime,
    assignedToId: assignedToId,
    notes: notes || "",
    visitType: visitType,
  };

  return await apiRequest("post", url, authContext, data);
}

export async function removeService(authContext, serviceId) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/providedservices/${serviceId}`;
  return await apiRequest("delete", url, authContext);
}

export async function updateServiceStatus(authContext, serviceId, status) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = "/api/providedservices/updatestatus";
  const data = {
    serviceId: serviceId,
    status: status,
  };

  return await apiRequest("post", url, authContext, data);
}

export async function changeAssignment(authContext, serviceId, assignedToId) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = "/api/providedservices/changeassignment";
  const data = {
    serviceId: serviceId,
    assignedToId: assignedToId,
  };

  return await apiRequest("post", url, authContext, data);
}

export async function getAvailableSlots(authContext, physicianId, serviceId, dates) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = "/api/providedservices/availableslots";
  const data = {
    physicianId: physicianId,
    serviceId: serviceId,
    dates: dates,
  };

  return await apiRequest("post", url, authContext, data);
}